module.exports = __webpack_public_path__ + "img/anzihong.f70aa4bb.png";